import { format_ist } from '../../../util_components/care_request/care_request_rules';

// Session page "Change history" (goserver .../sessions/:uuid/history). The server sends readable text; these helpers
// only guard the shape and decide what the list shows.

export const VISIBLE_DEFAULT = 10;

// The entries of a response, or [] for anything that is not one (an empty / older response never breaks the page).
export function history_entries(view) {
  if (!view || !Array.isArray(view.entries)) return [];
  return view.entries.filter((e) => e && typeof e === 'object');
}

// "06 Oct 2026, 03:00 PM IST · Care One"
export const entry_meta = (entry) =>
  `${format_ist(entry.at)} · ${entry.actor_name || 'Unknown user'}`;

// goserver changehistory.ActionBannedEarlyExitRemoved: the engine dropped a banned student's early-exit penalty.
export const ACTION_BANNED_EARLY_EXIT_REMOVED = 'auto_removed_banned_student';

// The label of an entry's note: a system removal carries its reason; every other entry the editor's note.
export const note_label = (entry) =>
  entry && entry.action === ACTION_BANNED_EARLY_EXIT_REMOVED ? 'Reason' : 'Note';

// goserver changehistory.SourceOlderLog: an entry read from the session logs that predate the audit trail.
export const SOURCE_OLDER_LOG = 'older_log';
export const OLDER_RECORD_LABEL = "Older record: who asked and notes weren't captured";

// The older-record label, or '' (an audit entry, or an older one a Care record now explains).
export const older_record_label = (entry) =>
  entry && entry.source === SOURCE_OLDER_LOG && !entry.request ? OLDER_RECORD_LABEL : '';

export const change_line = (c) => `${c.label}: ${c.from || '--'} → ${c.to || '--'}`;

// The rows on screen: the newest VISIBLE_DEFAULT until "Show all" is pressed.
export const visible_entries = (entries, show_all) =>
  show_all ? entries : entries.slice(0, VISIBLE_DEFAULT);

// What the request block says about the screenshot: a link, a failed link, or nothing.
export function screenshot_state(request) {
  if (!request || !request.has_screenshot) return 'none';
  if (request.screenshot_url) return 'link';
  return 'unavailable';
}
